export const LABEL_UNDERGRADUATE = "undergraduate";
export const LABEL_GRADUATE = "graduate";
export const LABEL_FALL_TERM = "fall";
export const LABEL_ARIZONA_RESIDENT = "Arizona resident";

export const TUITION_DEGREE_TYPE_LABELS = {
  Undergraduate: "undergraduate degree",
  Exploratory: "undergraduate degree",
  Graduate: "graduate degree",
  Certificates: "graduate certificate"
} as const;

export const TUITION_CREDIT_OPTION_LABELS = {
  "part-time": "Part-time student",
  "full-time": "Full-time student",
  manual: "Enter credits"
} as const;

export const TUITION_RESIDENCY_LABELS = {
  res: "I’m an Arizona resident",
  nores: "I’m an out-of-state resident"
} as const;
